/* eslint-disable max-len */
/**
 * Greek translations.
 */
export default {
  ACTION: {},
  ERROR: {
    DELETE_TWITCH: 'Ακύρωση της ενσωμάτωσης του Twitch',
    ERROR: 'Σφάλμα',
    FETCH_DATA: 'Λήψη δεδομένων'
  },
  HEADER: {
    DATE: 'Ημερομηνία',
    MESSAGE: 'Μήνυμα',
    NAME: 'Όνομα',
    ORDER_CODE: 'Cod. Enc.',
    ORDER_VALUE: 'Αξία'
  },
  LABEL: {
    ACTIVE_SINCE: 'Ενεργό από',
    INTEGRATIONS: 'Ενσωματώσεις',
    TWITCH: 'Twitch',
    TWITCH_AUTH: 'Εξουσιοδότηση Twitch',
    TWITCH_AUTHORIZED_INFORMATION:
      'Το Prozis έχει την άδεια να δημιουργεί ειδοποιήσεις στο Twitch κατά τη διάρκεια των ροών.',
    TWITCH_INFORMATION:
      'Η Prozis θα ζητήσει εξουσιοδότηση για τη δημιουργία ειδοποιήσεων Twitch κατά τη διάρκεια των ροών.',
    TWITCH_INTEGRATION: 'Ενσωμάτωση Twitch'
  },
  SENTENCE: {},
  SUCCESS: {
    DELETE_TWITCH: 'Η ενσωμάτωση του Twitch ακυρώθηκε',
    SUCCESS: 'Επιτυχία'
  },
  TOOLTIP: {
    ORDER_CODE: 'Κωδικός παραγγελίας'
  }
};
